import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent implements OnInit {

  acceptTerms: boolean;

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  next() {
    if (this.acceptTerms) {
      this.router.navigate(['invoice-options']);
    }
  }

  doTerms() {
    window.open('https://www.bancosemear.com.br/politica-de-privacidade', '_blank');
  }

}
